import { Dayjs } from 'dayjs';

export const subtractHour = (date: Dayjs, hour: number): Dayjs =>
  date.subtract(hour, 'hour');

export const subtractDay = (date: Dayjs, day: number): Dayjs =>
  date.subtract(day, 'day');
